// extracted by mini-css-extract-plugin
export var container = "newsletter-module--container--OSaM2";
export var banner = "newsletter-module--banner--uSrzZ";
export var content = "newsletter-module--content--U3A1T";
export var visual = "newsletter-module--visual--4B0je";
export var copy = "newsletter-module--copy--LYkQq";
export var input = "newsletter-module--input--fUFqZ";
export var button = "newsletter-module--button--upwPM";
export var legal = "newsletter-module--legal--P4OKy";
export var fadein = "newsletter-module--fadein--pFcB+";